import React from 'react'

export default function Artists() {
  return (
    <div className="screen-game">
      <h1>Artists</h1>
      <div style={{backgroundPosition : 'center', backgroundSize : 'cover'}}>
          <img src="./img/artists.jpg" alt="..." />          
      </div>
    </div>
  )
}
